class AppConfigService {
  static getConfig() {
    return window.appConfig
  }
}

export default AppConfigService
